import { render, staticRenderFns } from "./RadioCard.vue?vue&type=template&id=1832a01e"
import script from "./RadioCard.vue?vue&type=script&lang=js"
export * from "./RadioCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports